import { getDecodedID, getEncodedID } from "./encodeAndDecode.utils";
import { getEncodedBudgetId } from "./budgets.utils";

export const getDecodedProposalId = (id: string) => {
  const [budgetId, proposalId] = JSON.parse(getDecodedID(id).split(":")[1]) as [number, number];
  return { budgetId, proposalId };
};
export const getEncodedProposalId = (budgetId: string | number, proposalId: string | number) =>
  getEncodedID(`Proposal:[${budgetId},${proposalId}]`);

type GetProposalLinkParams = {
  entitySubdomain: string;
  budgetId: number;
  proposalId: number;
};
export const getProposalLink = ({ entitySubdomain, budgetId, proposalId }: GetProposalLinkParams) => {
  const encodedBudgetId = getEncodedBudgetId(budgetId);
  const encodedProposalId = getEncodedProposalId(budgetId, proposalId);
  return `/budgets/${entitySubdomain}/${encodedBudgetId}/proposals/${encodedProposalId}`;
};
